export function formatDuration(seconds: number): string {
  const s = Math.max(0, Math.round(seconds));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return s % 60 ? `${m}m ${String(s % 60).padStart(2, "0")}s` : `${m}m`;
  const h = Math.floor(m / 60);
  return m % 60 ? `${h}h ${m % 60}m` : `${h}h`;
}

export const STEP_LABELS: Record<string, string> = {
  opened: "Opened",
  draft_created: "Draft created",
  generate: "Generated",
  field_edited: "Field edited",
  section_toggled: "Section toggled",
  fact_toggled: "Fact toggled",
  conclusion_rewritten: "Conclusion rewritten",
  screenshot_added: "Screenshot added",
  screenshot_removed: "Screenshot removed",
  pdf_downloaded: "PDF downloaded",
  package_downloaded: "Package downloaded",
  abandoned: "Abandoned",
  submitted: "Submitted",
};

export const BUCKET_LABELS: Record<string, string> = {
  screenshots: "Screenshots",
  reviewing: "Reviewing the preview",
  fields: "Fields and sections",
  rewrites: "Conclusion rewrites",
};

export const PROCESSOR_LABELS: Record<string, string> = {
  shopify: "Shopify",
  paypal: "PayPal",
  stripe: "Stripe",
  adyen: "Adyen",
  bank: "Bank",
};

export const OUTCOME_LABELS: Record<string, string> = { finished: "Submitted", downloaded: "Downloaded", open: "Still open", abandoned: "Abandoned" };
export const RESULT_LABELS: Record<string, string> = { won: "Won", lost: "Lost", awaiting: "Awaiting result" };

const FIELD_LABELS: Record<string, string> = {
  arn: "ARN",
  noContactAttested: "No-contact attestation",
  conclusion: "Conclusion",
  productDescriptions: "Product descriptions",
  customerContact: "Customer contact",
  manualRefund: "Manual refund",
  storefrontId: "Storefront",
  digitalDetails: "Digital details",
  trackingNumber: "Tracking number",
  shopifyAnswers: "Shopify answers",
  paypalNotes: "PayPal notes",
  stripeAnswers: "Stripe answers",
};

/** `customer_communication` / `refundPolicy` → "Customer communication" / "Refund policy". */
function humanise(key: unknown): string {
  const s = String(key ?? "");
  if (FIELD_LABELS[s]) return FIELD_LABELS[s];
  const words = s.replace(/_/g, " ").replace(/([a-z])([A-Z])/g, "$1 $2").toLowerCase();
  return words.charAt(0).toUpperCase() + words.slice(1);
}

export function detailText(step: string, detail: Record<string, unknown> | null): string {
  if (!detail) return "";
  switch (step) {
    case "conclusion_rewritten":
    case "generate": return [detail.waitSeconds != null ? `${detail.failed ? "failed" : "ready"} after ${formatDuration(Number(detail.waitSeconds))} · wait not counted` : detail.failed ? "failed" : null, detail.attentionItems != null ? `${detail.attentionItems} attention items` : null].filter(Boolean).join(" · ");
    case "field_edited": return [humanise(detail.field), detail.value].filter(Boolean).join(" · ");
    case "section_toggled": return `${humanise(detail.section)} ${detail.on ? "on" : "off"}`;
    case "fact_toggled": return `${humanise(detail.fact)} ${detail.on ? "on" : "off"}`;
    case "screenshot_added": return `${humanise(detail.slot)} · ${detail.files} file${Number(detail.files) === 1 ? "" : "s"}`;
    case "draft_created": return [detail.orderType, detail.orderSource].filter(Boolean).map(humanise).join(" · ");
    case "package_downloaded": return humanise(detail.file);
    default: return "";
  }
}
